import { Produto, ItemPedido } from '../models/model'; 
import 'rxjs/add/operator/catch';

export class CarrinhoPedidoService {
    items: ItemPedido[] = [];

    clear(){
        this.items = [];
    }

    addItem(item: Produto){
        let fondItem = this.items.find((mItem) => mItem.produto.codigo === item.codigo);
        if (fondItem){
            this.increaseQtd(fondItem);
        } else {
            this.items.push(new ItemPedido(item));
        }
    }

    addItemQtd(item: Produto, quantidade){
        let fondItem = this.items.find((mItem) => mItem.produto.codigo === item.codigo);
        this.items.push(new ItemPedido(item, quantidade));
    }

    removeItem(item: ItemPedido){
        this.items.splice(this.items.indexOf(item), 1);
    }

    increaseQtd(item: ItemPedido){
        item.quantidade = item.quantidade + 1;
    }

    decreaseQtd(item: ItemPedido){
        item.quantidade = item.quantidade - 1;
        if (item.quantidade === 0) {
            this.removeItem(item);
        }
    }

    total(): number {
        return this.items
            .map(item => item.total())
            .reduce((prev, value) => prev + value, 0);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/carrinho-pedido.service.ts